import React from 'react'

export const ReturnPolicy = () => {
return(
    <div class="p-20 w-100 fs-5">
    <h1 className='h1 mb-10'>Return Policy</h1>
    <p>
    We are committed to ensuring the satisfaction of our customers. Please review our return policy carefully to understand the terms and conditions for returning a device.
    </p>

    <h2 className='h2 mt-10 mb-4'>Eligibility for Returns</h2>
    <p>
    <li>Returns are accepted within 14 days after the delivery date.</li>
    <li>The device must be defective or non-functional upon arrival to qualify for a return.</li>
    <li>Devices that are damaged due to misuse or accidents are not eligible for returns.</li>
    </p>

    <h2 className='h2 mt-10 mb-4'>Return Process</h2>
    <p>
    <li>To initiate a return, please contact our customer support team within the 14-day window.</li>
    <li>Provide proof of purchase and a description or evidence of the issue with the device.</li>
    <li>Once approved, we will guide you through the return shipping process.</li>
    </p>

    <h2 className='h2 mt-10 mb-4'>Refund or Replacement</h2>
    <p>
    <li>If the device is confirmed to be defective, you may choose between a replacement or a full refund.</li>
    <li>Refunds will be processed within 7 business days after we receive and inspect the returned device.</li>
    </p>

    <h2 className='h2 mt-10 mb-4'>Our Commitment</h2>
    <p>
    We strive to deliver high-quality products and excellent service. If you have any concerns or questions about your purchase, please do not hesitate to reach out to our support team for assistance.
    </p>

</div>
)
}
